import React, { useContext, useEffect, useState } from "react";
import AppDataContext from "../../context/AppDataContext";
import useWindowSize from "../../hooks/useWindowSize";
import Filters from "./components/Filters/Filters";
import MapBox from "../../components/MapBox/MapBox";
import TimeLine from "../../components/WorldMap/components/TimeLine/TimeLine";
import { GeoRiskData } from "./data/MapData";

import RiskNews from "./components/RiskNews/RiskNews";
import RiskScan from "../RiskScan/RiskScan";

export default function Scan() {
  const { setHeaderShow, setHeaderData, user, setShowBackArrow }: any = useContext(AppDataContext);
  const { isUltraWide } = useWindowSize();

  useEffect(() => {
    setHeaderShow(true);
    setShowBackArrow(isUltraWide);
    setHeaderData({
      title: `Risk Scanning`,
    });
  }, [isUltraWide]);

  return (
    <div className="container-fluid" style={{ borderTop: "1px solid #3A3A4A" }}>
      {/* {isUltraWide && } */}

      <div className="row">
        {isUltraWide && (
          <div className="col-3" style={{ padding: "2rem" }}>
            <Filters />
          </div>
        )}

        <div className={isUltraWide ? "col-6 pt-4" : "col"}>
          <RiskScan
            mapHeight={isUltraWide ? "23rem" : "17rem"}
            isShowFilter={!isUltraWide}
          />
        </div>

        {isUltraWide && (
          <div className="col-3 pt-4">
            <RiskNews />
          </div>
        )}
      </div>
    </div>
  );
}
